define([
    'edge/quoteandbind/common/models/Submission'
], (Submission)=> {
    return ['$q',
        'JsonRPCService',
        'qnb.ErrorHandlingService',
        function ($q, JsonRPCService, ErrorHandlingService) {
            return {

                createSubmission(callGroups, submissionDTO) {
                    const deferred = $q.defer();
                    JsonRPCService.send('quote', 'slquote', 'createBaseOffering', [submissionDTO], callGroups).then(
                        (response) => {
                            submissionDTO = new Submission(response);
                            ErrorHandlingService.checkSessionUUID(submissionDTO, deferred);
                            return deferred.resolve(submissionDTO);
                        }, (error, status, headers) => {
                            return deferred.reject([error, status, headers]);
                        });
                    return deferred.promise;
                }
            };
        }];
});


/** WEBPACK FOOTER **
 ** ./common/js/src/edge/quoteandbind/quickquote/common/services/QuickQuoteService.js
 **/